var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"build-1753885214578"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'
import { replayIntegration } from '@sentry/replay'
import Cookies from 'js-cookie'

const CONSENT_COOKIE = 'USE_COOKIE_CONSENT_STATE'
let initialized = false

function hasThirdPartyConsent() {
  const raw = Cookies.get(CONSENT_COOKIE)
  if (!raw) return false
  try {
    const parsed = JSON.parse(raw)
    return parsed.thirdParty === true
  } catch {
    return false
  }
}

export function initSentry() {
  if (initialized || !hasThirdPartyConsent()) {
    return
  }
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    integrations: [replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate:
      process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    enabled: process.env.NODE_ENV === 'production',
    environment: process.env.SENTRY_ENVIRONMENT,
  })
  initialized = true
}

export function closeSentry() {
  if (initialized) {
    Sentry.close()
    initialized = false
  }
}

initSentry()
